import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {ToastrService} from "ngx-toastr";
import {DataService} from "../../../services/data.service";
import {GlobalConstants} from "../../../common/global-constants";
import {ConfigurationService} from "../../../services/configuration.service";
import {AuthenticationService} from "../../../services/authentication.service";
import {CommonUtils} from "../../../utils/common.utils";
import {forkJoin, Observable} from "rxjs";
import { MatDialog } from "@angular/material/dialog";
import {CronComponent} from "./cron/cron.component";
import {DialogService} from "../../../services/dialog.service";
import {AddThresholdConfirmDialogData} from "./add-threshold-confirm-dialog/add-threshold-confirm-dialog.component";
import {DeleteThresholdConfirmDialogData} from "./delete-threshold-confirm-dialog/delete-threshold-confirm-dialog.component";

@Component({
  selector: 'app-update-validation-threshold',
  templateUrl: './update-validation-threshold.component.html',
  styleUrls: ['./update-validation-threshold.component.scss']
})
export class UpdateValidationThresholdComponent implements OnInit {

  @ViewChild(CronComponent) private cronComponent: CronComponent;

  fetchAllTransitTimeValidationThresholdUrl : string = GlobalConstants.FETCH_ALL_TRANSIT_TIME_VALIDATION_THRESHOLD;
  saveTransitTimeUpdateValidationThresholds : string = GlobalConstants.SAVE_TRANSIT_TIME_UPDATE_VALIDATION_THRESHOLDS;
  deleteTransitTimeUpdateValidationThresholds : string = GlobalConstants.DELETE_TRANSIT_TIME_UPDATE_VALIDATION_THRESHOLDS;
  fetchTransitTimeUpdateValidationRulesUrl : string = GlobalConstants.FETCH_TRANSIT_TIME_UPDATE_VALIDATION_RULES;
  approvalRequestUrl: string = GlobalConstants.SUBMIT_TRANSIT_TIME_APPROVAL_REQUEST_ENDPOINT;
  updateValidationThresholdForm: FormGroup;
  loading = false;
  firstLoad = true;
  records: any[];
  fromCountryCodeOptions: any[];
  transitTimeOptions: string[];
  transitTimeUpdateValidationThresholdList = [];
  transitTimeUpdateValidationBaseThresholdList = [];
  countryCodes: any;
  currentComponentKeyPlaceholder = [];
  currentWorkingRecord: any;
  items: any;
  dropDownOptions: any;
  help_messages: any = this.dataService.help_messages;
  user = {};
  requestBody: { } ;
  hasPermission = false;
  
  get passportEnabledShipmethods(){
    return this.dataService.passportEnabledShipmethods;
  }

  constructor(@Inject('RequestsService') private requestsService,
              @Inject('DataPathUtils') private dataPathUtils,
              @Inject('ConfigurationService') private readonly configurationService: ConfigurationService,
              @Inject('CommonUtils') private readonly commonUtils: CommonUtils,
              @Inject('AuthenticationService') private readonly authenticationService: AuthenticationService,
              @Inject('DialogService') private dialogService,
              private formBuilder: FormBuilder,
              private toastrService: ToastrService,
              private dataService: DataService,
              private dialog: MatDialog) {
  }

  ngOnInit() {
    forkJoin(
      this.configurationService.getSettings(),
    ).subscribe(([settings]) => {
      this.user = this.authenticationService.getUserDetails();

      this.countryCodes = settings.countryCodes;
    });
    this.updateValidationThresholdForm = this.formBuilder.group({
      businessUseCase: ['', Validators.required],
      fromCountryCode: ['', Validators.required],
      componentKeyPlaceholder: [''],
      componentKeyValue: ['', Validators.required],
      transitTimeType: ['', Validators.required]
    });
    this.fromCountryCodeOptions = this.commonUtils.getFromCountryCodes();
    this.transitTimeOptions = this.dataService.transitTimeOptions;
    this.items = this.commonUtils.getItemsBasedOnArc();
  }

    /**
   * Checks user permissions and updates loading/hasPermission state.
   * Returns true if the user has permission, false otherwise.
   */
  private async checkUserPermissions(): Promise<boolean> {
    try {
      this.loading = true;
      const hasPermission = await this.dataService.checkUserPermissions(this.requestBody);
      this.loading = false;
      if (hasPermission === false) {
        this.toastrService.error(GlobalConstants.NO_PERMISSION_MSG, GlobalConstants.TITLE_ERROR);
      }
      return hasPermission;
    } catch (error) {
      this.loading = false;
      console.error(GlobalConstants.CHECK_USER_PERMISSIONS_ERROR, error);
      this.toastrService.error(GlobalConstants.SOMETHING_WENT_WRONG, GlobalConstants.TITLE_ERROR);
      return false;
    }
  }

  get getItems(){
    return this.commonUtils.getItemsBasedOnArc()
  }

  onFromCountryCodeChange(fromCountryCode: string) {
    this.loading = true;
    this.currentWorkingRecord = {};
    this.updateValidationThresholdForm.get(GlobalConstants.BUSINESS_USE_CASE).setValue('');
    this.updateValidationThresholdForm.get(GlobalConstants.COMPONENT_KEY_PLACE_HOLDER).setValue('')
    this.currentComponentKeyPlaceholder = [];
    this.dataService.getConfigurationRecordsBasedOnFromCountryCode(fromCountryCode).subscribe((data: any[]) => {
      this.loading = false;
      this.records = data[GlobalConstants.TRANSIT_TIME_CONFIGURATIONS_RESPONSE_KEY];
      console.log(data)
    }, error => {
      this.loading = false;
      this.toastrService.error(error, GlobalConstants.TITLE_ERROR);
    });
  }

  onBusinessUseCaseChange(businessUseCase) {
    this.currentWorkingRecord = this.commonUtils.getCurrentWorkingRecord(businessUseCase);
    this.dropDownOptions = this.commonUtils.getDropDownOptions(this.currentWorkingRecord, this.records);
    this.updateValidationThresholdForm.get(GlobalConstants.COMPONENT_KEY_PLACE_HOLDER).setValue(this.currentWorkingRecord[GlobalConstants.COMPONENT_KEY_PLACE_HOLDER])
    this.currentComponentKeyPlaceholder = this.currentWorkingRecord[GlobalConstants.COMPONENT_KEY_PLACE_HOLDER].split(GlobalConstants.COMPONENT_KEY_VALUE_SEPARATOR);
    this.updateValidationThresholdForm.setControl(GlobalConstants.COMPONENT_KEY_VALUE, this.getComponentKeyValueFormGroup());
    this.updateValidationThresholdForm.get(GlobalConstants.TRANSIT_TIME_TYPE).setValue('');
  }

  private getComponentKeyValueFormGroup() {
    let componentKeyPlaceValueFormGroupInput = {};
    for (let componentKey of this.currentComponentKeyPlaceholder) {
      componentKeyPlaceValueFormGroupInput[componentKey] = new FormControl('', Validators.required)
    }
    return this.formBuilder.group(componentKeyPlaceValueFormGroupInput);
  }

  public async onGetAllThresholds() {
    this.firstLoad = false;
    this.hasPermission = false;
    this.createRequestBody();
    this.hasPermission = await this.checkUserPermissions();
    if (!this.hasPermission) return;
    this.getAllThresholds();
    this.getValidationRules()
  }

  public async onAddThreshold() {
    this.createRequestBody();
    if (!(await this.checkUserPermissions())) return;
    //Open Cron Dialog Box to get CronExpressionRule
    this.dialog.open(CronComponent).afterClosed().subscribe(metadata => {
        if(metadata.cronExpression !== null){
          this.getConfirmationFromUser(metadata).subscribe(isConfirmed => {
            if(isConfirmed){
              this.addOrEditThreshold(metadata)
            }})
        }});
  }

  public async onEditThreshold(row){
    this.createRequestBody()
    if (!(await this.checkUserPermissions())) return;
    this.dialogService.openEditThresholdDialog(row).subscribe(data => {
      if(data !== undefined){
        //Edit Threshold
        row['threshold'] = data
        this.addOrEditThreshold(row)
      }
    })
  }

  public async onDeleteThreshold(row){
    this.createRequestBody()
    if (!(await this.checkUserPermissions())) return;
    let deleteThresholdConfirmDialogData : DeleteThresholdConfirmDialogData = {
      transitTime: row.transitTime,
      threshold: row.threshold,
      cronDescriptor: row.cronDescriptor,
      componentKeyValue: this.requestBody[GlobalConstants.COMPONENT_KEY_VALUE]
    }
    this.dialogService.openDeleteThresholdConfirmDialog(deleteThresholdConfirmDialogData).subscribe( data => {
      if(data){
        this.loading = true;
        this.requestBody["transitTimeUpdateValidationThreshold"] = row
        console.log(this.requestBody)
        this.requestsService.put(this.deleteTransitTimeUpdateValidationThresholds, this.requestBody).subscribe(data => {
          this.getAllThresholds()
        }, error => {
          this.loading = false;
          this.toastrService.error(error, GlobalConstants.TITLE_ERROR);
        });
      }
    });
  }

  private getAllThresholds(){
    this.requestsService.put(this.fetchAllTransitTimeValidationThresholdUrl, this.requestBody).subscribe(data => {
      this.loading = false;
      this.transitTimeUpdateValidationThresholdList = data["transitTimeUpdateValidationThresholdList"]
    }, error => {
      this.loading = false;
      this.toastrService.error(error, GlobalConstants.TITLE_ERROR);
    });
  }

   private addOrEditThreshold(metadata){
    this.loading = true;
    metadata.transitTime = metadata.transitTime.replace("ALL", "*");
    this.requestBody["transitTimeUpdateValidationThreshold"] = metadata
    console.log(this.requestBody)
    this.requestsService.put(this.saveTransitTimeUpdateValidationThresholds, this.requestBody).subscribe(data => {
      this.getAllThresholds()
    }, error => {
      this.loading = false;
      this.toastrService.error(error, GlobalConstants.TITLE_ERROR);
    });
  }

  private createRequestBody(){
    this.requestBody = JSON.parse(JSON.stringify(this.updateValidationThresholdForm.value));
    this.requestBody[GlobalConstants.BUSINESS_UNIT] = this.currentWorkingRecord[GlobalConstants.BUSINESS_UNIT];
    this.requestBody[GlobalConstants.COMPONENT_KEY_VALUE] = this.commonUtils.buildComponentKeyValue(this.requestBody[GlobalConstants.COMPONENT_KEY_VALUE], this.requestBody[GlobalConstants.COMPONENT_KEY_PLACE_HOLDER]);
    this.requestBody[GlobalConstants.TRANSIT_TIME_TYPE]
    this.requestBody[GlobalConstants.CREATED_BY] = this.user[GlobalConstants.ALIAS];
    console.log(this.requestBody)
  }

  private getConfirmationFromUser(metadata): Observable<boolean> {
    let addThresholdConfirmDialogData : AddThresholdConfirmDialogData = {
      transitTime: metadata.transitTime,
      threshold: metadata.threshold,
      cronDescriptor: metadata.cronDescriptor,
      componentKeyValue: this.requestBody[GlobalConstants.COMPONENT_KEY_VALUE]
    }
    return this.dialogService.openAddThresholdConfirmDialog(addThresholdConfirmDialogData)
  }

  private  getValidationRules(){
    this.requestBody["ruleType"] = "DeepRule"
    this.requestsService.put(this.fetchTransitTimeUpdateValidationRulesUrl, this.requestBody).subscribe(data => {
      this.loading = false;
      const deltaChangeBaseRule = data["rules"][1]["rule"]
      this.transitTimeUpdateValidationBaseThresholdList = []
      for(let transitTime in deltaChangeBaseRule)
        this.transitTimeUpdateValidationBaseThresholdList.push(
          {
            transitTime : transitTime,
            threshold : deltaChangeBaseRule[transitTime]["threshold"]
          }
        )
    }, error => {
      this.loading = false;
      this.toastrService.error(error, GlobalConstants.TITLE_ERROR);
    });
  }
}
